export default __webpack_public_path__ + "static/google-play-badge-ru-2ab3dacf80f16a3e6bca76dc8b62bdb6.png";